import React from "react";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputText} from "primereact/inputtext";

const StoreTableSection = ({
	filteredItems,
	isLoading,
	updateCounter,
	selectedSerialAmount,
	setSelectedSerialAmount,
}) => {
	const renderQuantityInput = (rowData) => (
		<InputText
			className="w-20 py-2 pl-2 border"
			onChange={(e) => setSelectedSerialAmount(e.target.value)}
			value={selectedSerialAmount}
			max={rowData.amount}
			type="number"
			min="1"
		/>
	);

	const renderBlockDisplay = (rowData) => {
		const blockName = rowData.unique?.block?.name;

		if (blockName) {
			return (
				<span className="px-3 py-1 text-sm text-green-700 bg-green-100 rounded-md">
					{blockName}
				</span>
			);
		} else {
			return (
				<span className="px-3 py-1 text-sm text-red-700 bg-red-100 rounded-md">
					Блок танланмаган
				</span>
			);
		}
	};

	const renderFurnitureName = (rowData) => {
		const komplektName =
			rowData.furniture?.komplekt_furniture?.[0]?.komplekt?.name || "";
		const categoryName = rowData.furniture?.category_furniture?.name || "";
		const furnitureName = rowData.furniture?.name || "";

		return `${komplektName} ${categoryName} ${furnitureName}`.trim();
	};

	return (
		<DataTable
			className="custom-row-border"
			value={filteredItems}
			loading={isLoading}
			key={`main-table-${updateCounter}`}
			emptyMessage="Маълумотлар топилмади">
			<Column
				className="min-w-[150px]"
				header="#"
				body={(rowData) => rowData.unique?.name || ""}
			/>
			<Column
				className="min-w-[150px]"
				header="МЕБЕЛ"
				body={renderFurnitureName}
			/>
			<Column
				className="min-w-[150px]"
				header="ОСТАТОК"
				body={(rowData) => rowData.amount || 0}
			/>
			<Column
				className="min-w-[150px]"
				header="К-ВО"
				body={renderQuantityInput}
			/>
			<Column
				className="min-w-[150px]"
				header="БЛОК"
				body={renderBlockDisplay}
			/>
		</DataTable>
	);
};

export default StoreTableSection;
